<template>
    <div>
        <div v-if="session.startup_application && currentUser.role != 'sso' && !isStartupEcosystem">
            <h1 class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase">
                {{ $t("nav.status")}}
            </h1>
        
            <h2 class="text-xbold text-blue text-2sm" v-if="session.startup_application && session.startup_application.application_session && session.startup_application.application_session.label && !loading">
                {{ session.startup_application.application_session.label }}
            </h2>
             <h2 class="text-xbold text-blue text-2sm" v-else-if="session.application_session && !loading">
                {{ session.application_session.label }}
            </h2>
            <loader v-if="loading"></loader>
            <div v-if="!showResult && !loading">
                <div v-if="((session.startup_application && session.application_session == null)||(session.application_session && session.startup_application.status ==0)) && !(ecosystemApp.application && ecosystemApp.application.status!=0)">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
                        <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white"> {{ $t("status.appNotSubmit")}} </p>
                    </div>
                    <div class="text-grey text-sm font-medium">
                        {{ $t("status.appNotSubmitMessage")}}
                    </div>
                </div>
                <div v-if="(session.application_session && session.startup_application.status!=0) || (ecosystemApp.application && ecosystemApp.application.status!=0)">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-success" style="background: linear-gradient(313.72deg, #AED880 0%, #76B049 100%)">
                        <i class="sp-icon-check-circle-1-copy text-green-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white">{{ $t('status.appSubmit')}} </p>
                    </div>
                    <div class="text-grey text-sm font-medium">
                        {{ $t('status.appSubmitMessage')}}
                    </div>
                </div>
            </div>
            <div class="lg:max-w-md" v-if="showResult && !loading">
                <div v-if="(session.startup_application && session.application_session == null)||(session.application_session && session.startup_application.status ==0)">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
                        <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white"> {{ $t("status.appNotSubmit")}} </p>
                    </div>
                    <div class="text-grey text-sm font-medium">
                        {{ $t("status.appNotSubmitMessage")}}
                    </div>
                </div>
        
                <div v-if="session.application_session && pending.includes(session.startup_application.status)">
                    <div v-if="session.application_session && pending.includes(session.startup_application.status)" class="flex items-center px-4 py-2 my-4 rounded-md shadow-success" style="background: linear-gradient(313.72deg, #AED880 0%, #76B049 100%)">
                        <i class="sp-icon-check-circle-1-copy text-green-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white">{{ $t('status.appSubmit')}} </p>
                    </div>
                    <div class="text-grey text-sm font-medium">
                        {{ $t('status.appSubmitMessage')}}
                    </div>
                </div>
                <div v-if="session.application_session && !pending.includes(session.startup_application.status) && session.startup_application.status !='9' && session.startup_application.status !='0'">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
                        <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white">
                            <span v-if="session.startup_application.status =='3'">{{ $t('feedback.app_refused1round')}}</span>
                            <span v-if="session.startup_application.status =='6'">{{ $t('feedback.app_refused2round')}} </span>
                            <span v-if="session.startup_application.status =='8'">{{ $t('feedback.app_refused3round')}} </span>
                            <span v-if="session.startup_application.status =='11'">{{ $t('candidat.Awaiting_further_information')}}</span>
                        </p>
                    </div>
                    <div class="text-grey text-sm font-medium" v-if="feedback">
                        {{feedback.appreciation}}
                    </div>
        
        
                </div>
        
        
                <div v-if="session.application_session && !pending.includes(session.startup_application.status) && session.startup_application.status =='9'">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-success" style="background: linear-gradient(313.72deg, #AED880 0%, #76B049 100%)">
                        <i class="sp-icon-check-circle-1-copy text-green-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white">{{ $t('feedback.app_'+session.startup_application.type+'_accepted')}}</p>
                    </div>
                    <div class="text-grey text-sm font-medium" v-if="feedback">
                        {{feedback.appreciation}}
                    </div>
                </div>
        
            </div>
        </div>
        <div v-else-if="currentUser.role == 'sso' || isStartupEcosystem">
            <h1 class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase">
                {{ $t("nav.status")}}
            </h1>
            <loader v-if="loading"></loader>
            <div v-if="ecosystemApp && ecosystemApp.application && (!ecosystemApp.application.result || ecosystemApp.application.result && ecosystemApp.application.result.status != '2') && !loading">
                <div v-if="ecosystemApp.application.status == 0">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
                        <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white"> {{ $t("status.appNotSubmit")}} </p>
                    </div>
                    <div class="text-grey text-sm font-medium">
                        {{ $t("status.appNotSubmitMessage")}}
                    </div>
                </div>
        
                <div v-else>
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-success" style="background: linear-gradient(313.72deg, #AED880 0%, #76B049 100%)">
                        <i class="sp-icon-check-circle-1-copy text-green-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white">{{ $t('status.appSubmit')}} </p>
                    </div>
                    <div class="text-grey text-sm font-medium">
                        {{ $t('status.appSubmitMessage')}}
                    </div>
                </div>
            </div>
            <div class="lg:max-w-md" v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.result && ecosystemApp.application.result.status == '2' && !loading">
                <div v-if="(ecosystemApp.application && ecosystemSession == null)||(ecosystemSession && ecosystemApp.application.status ==0)">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
                        <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white"> {{ $t("status.appNotSubmit")}} </p>
                    </div>
                    <div class="text-grey text-sm font-medium">
                        {{ $t("status.appNotSubmitMessage")}}
                    </div>
                </div>

                <div v-if="ecosystemSession && pending.includes(ecosystemApp.application.status)">
                    <div v-if="ecosystemSession && pending.includes(ecosystemApp.application.status)" class="flex items-center px-4 py-2 my-4 rounded-md shadow-success" style="background: linear-gradient(313.72deg, #AED880 0%, #76B049 100%)">
                        <i class="sp-icon-check-circle-1-copy text-green-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white">{{ $t('status.appSubmit')}} </p>
                    </div>
                    <div class="text-grey text-sm font-medium">
                        {{ $t('status.appSubmitMessage')}}
                    </div>
                </div>
                <div v-if="ecosystemSession && !pending.includes(ecosystemApp.application.status) && ecosystemApp.application.status !='9' && ecosystemApp.application.status !='0'">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
                        <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white">
                            <span v-if="ecosystemApp.application.status =='3'">{{ $t('feedback.app_refused1round')}}</span>
                            <span v-if="ecosystemApp.application.status =='6'">{{ $t('feedback.app_refused2round')}} </span>
                            <span v-if="ecosystemApp.application.status =='8'">{{ $t('feedback.app_refused3round')}} </span>
                            <span v-if="ecosystemApp.application.status =='11'">{{ $t('candidat.Awaiting_further_information')}}</span>
                        </p>
                    </div>
                    <div class="text-grey text-sm font-medium pre-formatted" v-html="ecosystemApp.application.result.appreciation" v-if="ecosystemApp.application.result"></div>
                </div>

                <div v-if="ecosystemSession && !pending.includes(ecosystemApp.application.status) && ecosystemApp.application.status =='9'">
                    <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-success" style="background: linear-gradient(313.72deg, #AED880 0%, #76B049 100%)">
                        <i class="sp-icon-check-circle-1-copy text-green-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
                        <p class="text-2sm text-bold text-white">{{ $t('feedback.ecosystem_app_accepted')}}</p>
                    </div>
                    <div class="text-grey text-sm font-medium pre-formatted" v-html="ecosystemApp.application.result.appreciation" v-if="ecosystemApp.application.result"></div>
                </div>
            </div>

            <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Certif' && !hasApps['Deal']" class="flex items-center shadow-ecosystem rounded-md p-8 my-12">
                <img
                    class="fill-current"
                    src="../assets/img/deal.svg"
                    alt="startup act deal logo"
                />
                <div class="ml-2">
                    <h3 class="float-left mb-2 text-base text-center ecosystem-application-title">
                        {{ $t('ecosystem.create_deal') }}
                    </h3><br>
                    <p class="mt-2">{{ $t('ecosystem.submit_deal') }}</p>
                </div>
                <div class="ml-auto">
                    <sp-button
                        @click="createDeal('deal')"
                        :disabled="ecosystemApp.application.type == 'Certif' && (
                            ecosystemApp.application.status == 0 ||
                            ecosystemApps.sessions['Deal'] == null ||
                            ecosystemApps.sessions['Deal'].status != 1 ||
                            ecosystemApps.sessions['Deal'].first_step_status != 1 ||
                            ecosystemApp.application.type == 'Certif' && ecosystemApp.application.user_id != this.currentUser.id ||
                            ( ['3', '6', '8', '11'].includes(ecosystemApp.application.status) && ecosystemApp.application.result != null )
                        ) ? true : false"
                        class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
                        >
                        <img
                            class="fill-current w-4 h-4 mr-2"
                            src="../assets/img/cand/Group Copy 2.svg"
                            alt="startup act action"
                        />
                        <span class="uppercase pr-4">{{$t('ecosystem.request_deal')}}</span>
                    </sp-button>
                </div>
            </div>
            <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Certif' && !hasApps['Sail']" class="flex items-center shadow-ecosystem rounded-md p-8 my-12">
                <img
                    class="fill-current"
                    src="../assets/img/sail.svg"
                    alt="startup act deal logo"
                />
                <div class="ml-2">
                    <h3 class="float-left mb-2 text-base text-center ecosystem-application-title">
                        {{ $t('ecosystem.create_sail') }}
                    </h3><br>
                    <p class="mt-2">{{ $t('ecosystem.submit_sail') }}</p>
                </div>
                <div class="ml-auto">
                    <sp-button
                        @click="createSail('sail')"
                        :disabled="ecosystemApp.application.type == 'Certif' && (
                            ecosystemApp.application.status == 0 ||
                            ecosystemApps.sessions['Sail'] == null ||
                            ecosystemApps.sessions['Sail'].status != 1 ||
                            ecosystemApps.sessions['Sail'].first_step_status != 1 ||
                            ecosystemApp.application.type == 'Certif' && ecosystemApp.application.user_id != this.currentUser.id ||
                            ( ['3', '6', '8', '11'].includes(ecosystemApp.application.status) && ecosystemApp.application.result != null )
                        ) ? true : false"
                        class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
                        >
                        <img
                            class="fill-current w-4 h-4 mr-2"
                            src="../assets/img/cand/Group Copy 2.svg"
                            alt="startup act action"
                        />
                        <span class="uppercase pr-4">{{$t('ecosystem.request_sail')}}</span>
                    </sp-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
</style>

<script>
import {
    FETCH_SESSION,
    FETCH_APPLICATION,
    CREATE_ECOSYSTEM_APP,
    CHECK_AUTH,
    FETCH_ECOSYSTEM_APPLICATION,
    FETCH_ECOSYSTEM_APPLICATIONS,
    SET_HAS_APPS,
    SET_ECOSYSTEM_SESSION
} from "@/store/actions.type";
import {
    mapGetters
} from "vuex";
import ApiService from "@/common/api.service";
import {SET_ApplicationMenuActive,SET_HashId,SET_APPLICATION_SESSION, SET_ECOSYSTEM_MENU_ACTIVE, SET_PROGRESS} from "@/store/mutations.type";
import Loader from "@/components/Loader.vue";
import { Fragment } from "vue-fragment";
import Button from "@/components/spKit/Button.vue";

export default {
    name: "feedback",
    components: {
        Loader,
        "fragment": Fragment,
        "sp-button": Button
    },
    data() {
        return {
            pending: ['1', '2', '4', '5', '7'],
            feedback: null,
            showResult: false,
            loading: true,
            ecosystemApps: [],
        }
    },
    mounted() {
        if(!this.currentUser.role){
              this.$store.dispatch(CHECK_AUTH)
                .then(role => this.fetchApplicationkData(role))
                .catch(() => {
                    this.$router.push({ name: "home" });
                });
        }else{
            this.fetchApplicationkData(this.currentUser.role)
        }
        this.getEcosystemApplicationsList();
    },
    methods: {
        getEcosystemApplicationsList() {
      this.$store
        .dispatch(FETCH_ECOSYSTEM_APPLICATIONS, this.currentUser.id)
        .then(data => {
          if (this.currentUser && this.currentUser.role && this.currentUser.role == 'sso') {
            this.exist_app = true;
            this.visible_add_candidate = true;
          }
          if (data.hasOwnProperty('applications')) {
            this.ecosystemApps = data;
            this.$store.commit(SET_HAS_APPS, data.applications);
            this.$store.commit(SET_ECOSYSTEM_SESSION, data.sessions);
          }
        }).catch(response => {
          if (this.currentUser && this.currentUser.role && this.currentUser.role == 'sso') {
            this.exist_app = true;
            this.visible_add_candidate = true;
          }
        })
    },
      fetchApplicationkData(role){
        if(role != 'sso'){
            if (localStorage.getItem('ecosystem') === 'true') {
                this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
                this.getFeedback();
            } else {
                this.$store.commit(SET_HashId,this.$route.params.app_id);
                this.$store.commit(SET_ApplicationMenuActive, 1);
                this.$store.dispatch(FETCH_APPLICATION, this.$route.params.app_id)
                    .catch(() => {
                        this.$router.push({ name: "home" });
                    });
            }
        }else{
          this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
          this.getFeedback();
        }
      },
      fetchFeedbackData(){
        ApiService.get(`/ecosystem/feedback/${this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id}`)
            .then(({ data }) => {
              this.$store.commit(SET_PROGRESS, data.data.progress)
              this.feedback = data.data.feedback;
              if (data.data != undefined && data.data.application != undefined && data.data.application.feedback != null) {
                this.feedback = data.data.application.feedback;
              }
              this.loading = false;
            })
            .catch(response => {
              this.showResult = false;
              this.loading = false;
            });
      },
      getFeedback() {
        if(!this.ecosystemApp.application){
            this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, this.$route.params.app_id)
                .then(() => this.fetchFeedbackData())
                .catch(() => {
                    this.$router.push({ name: "home" });
                });
        }else{
            this.fetchFeedbackData()
        }
      },
      createDeal(type) {
          this.$store
            .dispatch(CREATE_ECOSYSTEM_APP, type)
            .then(() => {
                this.$router.push({
                    name: "DealForm",
                    params: {
                    formName: 'deal-form',
                    ecoAppId: this.ecosystemApp.application.hash_id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                    }
                });
            })
            .catch(error => {
                this.$router.push({ name: "home" });
            })
      },
      createSail(type) {
          this.$store
            .dispatch(CREATE_ECOSYSTEM_APP, type)
            .then(() => {
                this.$router.push({
                    name: "SailForm",
                    params: {
                    formName: 'sail-form',
                    ecoAppId: this.ecosystemApp.application.hash_id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                    }
                });
            })
            .catch(error => {
                this.$router.push({ name: "home" });
            })
      }
    },
    watch: {
        startup_application() {
            if (
                this.startup_application != null 
            ) {
                ApiService.get(`/application/${this.hashId}/feedback`)
                    .then(({
                        data
                    }) => {
                        this.feedback = data.data.feedback;
                        this.showResult = true;
                        this.loading = false;
                        this.$store.commit(SET_APPLICATION_SESSION,data.data.application_session);
                    })
                    .catch(response => {
                        this.showResult = false;
                        this.loading = false;
                    });
            }
        },
        currentUser() {
            if (this.currentUser.role == 'sso') {
                this.getEcosystemApplicationsList();
            } else {
                this.$store
                .dispatch(FETCH_APPLICATION)
                .then(data => {
                    this.fetchApplications();
                })
                .catch(response => {
                    this.can_apply_app = true;
                    this.visible_add_candidate = true;
                });
                this.getEcosystemApplicationsList();
            }
        },
    },
    computed: {
        ...mapGetters([
            "session",
            "startup_application",
            "ApplicationMenuActive",
            "hashId",
            "currentUser",
            "ecosystemApp",
            "hasApps",
            "ecosystemProgress",
            "ecosystemSession"
        ]),
        isStartupEcosystem() {
            let startupEco = false;
            if (this.$route.params.app_id) {
                let hashId = this.$route.params.app_id;
                if (
                    this.ecosystemApp &&
                    this.ecosystemApp.application &&
                    ["Air", "Air2", "D4D"].includes(this.ecosystemApp.application.type) &&
                    this.ecosystemApp.application.id == hashId
                ) {
                    startupEco = true;
                }
            }
            return startupEco;
        }
    },
    beforeDestroy() {
        this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, false);
    }

}
</script>

<style>
    .shadow-ecosystem {
        -webkit-box-shadow: 0 2px 14px 0 rgb(29 57 100 / 62%);
        box-shadow: 0 2px 8px 0 rgb(29 57 100 / 62%);
    }
    .pre-formatted {
        white-space: pre-line;
    }
</style>
